import { ApiClient, ApiErrorMessage } from './ApiClient';

export interface AnemometersType {
  average: string;
  average_red: boolean;
  max: string;
  max_red: boolean;
  time: string;
}

export const AnemometersApi = async (): Promise<AnemometersType> => {
  try {
    const response = await ApiClient.get<AnemometersType>('/anemometers', {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return response.data;
  } catch (err) {
    const errorMsg = ApiErrorMessage(err);
    console.error(errorMsg);
  }

  return {
    average: '',
    average_red: false,
    max: '',
    max_red: false,
    time: ''
  };
};
